export default __webpack_public_path__ + "static/media/gitpy.8d360fc5.png";